import React, { Fragment, useState, useEffect } from "react";
import headerimage from ".././../../../../images/foods/menu-header-bg.png";
import footerimage from ".././../../../../images/foods/menu-footer-bg.png";

const SlotPdf = ({selectedDateName,selectedDateFormat,selectedViewMoreslotsDetails}) => {
    const styles = {
      

      page: {
        marginLeft: "1rem",
        marginRight: "1rem",
        "page-break-after": "always"
      },
  
      columnLayout: {
        display: "flex",
        justifyContent: "space-between",
        margin: "3rem 0 5rem 0",
        gap: "2rem"
      },
  
      column: {
        display: "flex",
        flexDirection: "column"
      },
  
      spacer2: {
        height: "2rem"
      },
  
      fullWidth: {
        width: "100%"
      },
  
      marginb0: {
        marginBottom: 0
      }
    };
    return (
      <>
       
           <div className="Header-con">
              <img
                className="img-fluid"
                src={headerimage}
                alt="FIS-Header"
                style={{ height: "101px", width: "100%" }}
              />
            </div>
            
            <div className="menu-body-con">
              <div
                className="slotDay text-center"
                style={{ paddingTop: "10px" }}
              >
                
                <h4>
                  
                  {selectedDateName} - {selectedDateFormat}
                </h4>
              </div>
              <div className="row">
                {/* <div className="col-md-4">
                <img
                  className="card-img-bottom img-fluid"
                  src={food25}
                  alt="Card cap"
                />

                <img
                  className="card-img-bottom img-fluid"
                  src={food10}
                  alt="Card cap"
                />

                <img
                  className="card-img-bottom img-fluid"
                  src={food4}
                  alt="Card cap"
                />
              </div> */}
             

                {selectedViewMoreslotsDetails &&
                  selectedViewMoreslotsDetails.map((items) => {
                    return (
                      <div className="row">
                        {items?.itemList &&
                          items?.itemList.map((subItem) => {
                            return (
                              <div className="col-md-6 row mt-2 ms-2">
                                 <div className="col-md-6">
                                  <img
                                    className="me-3 img-fluid item-img"
                                    src={subItem.itemPath}
                                    width="100px"
                                    height="100px"
                                    alt="DexignZone"
                                  />
                                </div> 
                                <div className="col-md-6">
                                  <b>{subItem.menuName} </b> <br />
                                  <b> ₹ {subItem.price} </b>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    );
                  })}
              </div>
            </div>

            <div className="menu-footer-con">
              <img
                className="img-fluid"
                src={footerimage}
                alt="FIS footer"
                style={{ height: "96px", width: "100%" }}
              />
            </div>



        
      </>
    );
  };
  
  export default SlotPdf;
  